<template>
    <div class="train-sign-up-root">
        <div class="main-content-wrap">
            <div class="nav_filter_wrap">
                <div class="up_wrap">
                    <div class="icon" @click="$router.push('/sm')">
                        <v-icon name="regular/arrow-alt-circle-left" scale="1.5"></v-icon>
                    </div>
                    <div class="main_wrap">
                        <div class="left">
                            <a
                                    v-for="(item, index) in nav"
                                    :key="index"
                                    :class="{'btn': true}"
                                    @click="switchTab(index)"
                            >{{item.name}}</a>
                        </div>
                        <div class="right">
                            <router-link to="/system/sys_class_plan" class="btn" v-if="!isFive">开班计划</router-link>
                            <div class="line"></div>
                            <router-link to="/system/heigh_class_plane" class="btn" v-if="!isFive">招标计划</router-link>
                            <router-link to="/system/train_sign_up" class="btn" v-if="!isFive">高端培训报名</router-link>
                            <span class="btn active">高端培训班</span>
<!--                            <span class="btn ">高端培训报名</span>-->
                            <!-- <router-link to class="btn">创建高端培训班</router-link> -->
                        </div>
                    </div>
                </div>
                <!-- <div class="down_wrap">
                    <div class="filter_line">
                        <span>级别：</span>
                        <span v-for="item in class_levels" :key="item.value"
                              @click="switchType('class_level', item.value)"
                              :class="{item:true,active: selectVal.class_level == item.value}">{{item.key}}</span>
                    </div>
                </div> -->
            </div>
            <div class="classMain">
                <div class="searchWrap" style="margin-bottom: 10px">
                    <div class="selectWrap">
                        <select
                          v-model="selectVal.class_train_type"
                          @change="search" v-if="!isFive">
                            <option value="">全部类型</option>
                            <option v-for="(item) in class_train_type_list"
                              :key="item.value"
                              :value="item.value">{{ item.key }}
                            </option>
                        </select>
                        <select
                                v-model="selectVal.org_id"
                                @change="search">
                            <option value="">承办机构</option>
                            <option v-for="(item) in organList"
                                    :key="item.org_id"
                                    :value="item.org_id">{{ item.name }}
                            </option>
                        </select>
                        <select
                                v-model="selectVal.status"
                                @change="search">
                            <option value="">全部状态</option>
                            <option v-for="(item) in selectStatus"
                                    :key="item.value"
                                    :value="item.value">{{ item.key }}
                            </option>
                        </select>
                        <select
                                v-model="selectVal.class_level"
                                @change="search">
                            <option value="">全部级别</option>
                            <option v-for="(item) in class_levels"
                                    :key="item.value"
                                    :value="item.value">{{ item.key }}
                            </option>
                        </select>
                        <select
                          v-model="selectVal.year"
                          @change="search" v-if="isFive">
                            <option value="">全部年份</option>
                            <option v-for="(item) in yearList"
                              :key="item.value"
                              :value="item.value">{{ item.value }}年
                            </option>
                        </select>
                    </div>
                    <!-- <div class="search">
                        <div class="wrap">
                            <input type="text" placeholder="请输入搜索内容" v-model.lazy="selectVal.keywords" >
                            <div v-show="selectVal.keywords!=''" class="close" @click="hideIcon">
                                <v-icon name="regular/times-circle" scale="1.2"></v-icon>
                            </div>
                        </div>
                        <div class="searchBtn"  @click="search">搜索
                        </div>
                        <div class="zuxie-btn" @click="ifDialogShow=true">创建培训班</div>
                    </div> -->
                </div>
                <div class="searchWrap">
                    <div class="selectWrap" >
                        <select
                          v-model="selectVal.year"
                          @change="search" v-if="!isFive">
                            <option value="">全部年份</option>
                            <option v-for="(item) in yearList"
                              :key="item.value"
                              :value="item.value">{{ item.value }}年
                            </option>
                        </select>
                    </div>
                    <div class="search">
                        <div class="wrap">
                            <input type="text" placeholder="请输入搜索内容" v-model.lazy="selectVal.keywords" >
                            <div v-show="selectVal.keywords!=''" class="close" @click="hideIcon">
                                <v-icon name="regular/times-circle" scale="1.2"></v-icon>
                            </div>
                        </div>
                        <div class="searchBtn"  @click="search">搜索
                        </div>
                        <div class="zuxie-btn" @click="ifDialogShow=true" v-if="!['viewer','viewFive'].includes(localUserInfo.member_type)">创建培训班</div>
                    </div>
                </div>
                <yioks-loading v-show="isLoading"></yioks-loading>
                <template v-if="!isLoading">
                    <template v-if="!showEmpty">
                        <div class="table">
                            <div class="thead">
                                <div class="tr">
                                    <div class="th index"><strong>序号</strong></div>
                                    <div class="th name"><strong>承办机构</strong></div>
                                    <div class="th  level "><strong>级别</strong></div>
                                    <div class="th  class_type "><strong>类型</strong></div>
                                    <div class="th num"><strong>期数</strong></div>
                                    <div class="th date"><strong>培训日期</strong></div>
                                    <div class="th status"><strong>状态</strong></div>
                                    <div class="th opt"><strong>操作</strong></div>
                                </div>
                            </div>
                            <div class="scrollArea">
                            <!-- height: 370px; -->
                                <vue-scroll :ops="ops" ref="vs">
                                    <div class="tbodyWrap">
                                        <div class="tbody">
                                            <div class="tr"
                                                 v-for="(item, index) in list"
                                                 :key="index">
                                                <div class="td index">
                                                    <p>{{index+1}}</p>
                                                </div>
                                                <div class="td name">
                                                    <p :title="item.org_abbreviation">{{item.org_abbreviation || '--'}}</p>
                                                </div>
                                                <div class="td level">
                                                    <p><span v-if="item.is_special_train">【快】</span> <span :title="item.class_level | enrollLevel">{{item.class_level | enrollLevel }}</span> </p>
                                                </div>
                                                <div class="td class_type">
                                                    <p><span :title="item.class_train_type | classType">{{item.class_train_type | classType }}</span> </p>
                                                </div>
                                                <div class="td num">
                                                    <p>{{item.periods}}</p>
                                                </div>
                                                <div class="td date">
                                                    <p>{{item.start_date | time(false) }} 至 {{item.end_date |time(false) }}</p>
                                                </div>
                                                <div class="td status">
                                                    <p>{{item.status  | enrollStatusSwitch}}</p>
                                                </div>
                                                <div class="td opt">
                                                    <p
                                                        :key="index"
                                                        @click="lookOver(item.c_id)"
                                                        :class="{
                                                            'msg_err': item.is_has_qualification == 1 || item.is_score_unusual_stu == 1 || item.is_repetition_stu == 1,
                                                        }"
                                                        :title="item.is_score_unusual_stu | tipMsg(item.is_repetition_stu, item.is_has_qualification)"
                                                        >查看</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </vue-scroll>
                            </div>
                        </div>
                        <div class="paging">
                            <yioks-paging :paging="paging"
                                          @goto-page="gotoPage($event)"></yioks-paging>
                        </div>
                    </template>
                    <div class="empty_wrap" v-show="showEmpty">
                        <yioks-empty h='100%'></yioks-empty>
                    </div>
                </template>
            </div>
        </div>

        <el-dialog
                :visible.sync="ifDialogShow"
                :close-on-click-modal="false"
                top="13vh"
                width="680px"
                custom-class="create-high-train-dialog"
        >
            <div class="select-level">
                <p class="title">创建培训班</p>
                 <div class="radio-wrap  " v-if="!isFive">
                    <div class="radio-title">类型：</div>
                    <!-- <el-radio-group v-model="classTrainType" class="radio-content">
                        <el-radio
                          v-for="item in class_train_type_list"
                          :label="item.value"
                          :key="item.value"
                          class="radio-item"
                          @change="toClassType(item.value)"
                          border
                        >{{item.key}}</el-radio>
                    </el-radio-group> -->

                    <el-select v-model="classTrainType" class="w360" placeholder="请选择培训班类型">
                        <el-option
                            v-for="item in class_train_type_list"
                            :key="item.value"
                            :label="item.key"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="radio-wrap enroll-type">
                    <div class="radio-title">级别：</div>
                    <el-radio-group v-model="classLevel"  class="radio-content">
                        <el-radio
                                v-for="item in levelOptions"
                                :label="item.value"
                                :key="item.value"
                                class="radio-item"
                                border
                        >{{item.name}}</el-radio>
                    </el-radio-group>
                </div>
               
                <div class="dia-footer">
                    <el-button class="button" type="primary" @click="toCreate">确定</el-button>
                    <el-button class="button" type="danger" @click="ifDialogShow=false">取消</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ops from "@/assets/js/vuescrollOption";
    import { HidgClassStatus ,class_train_type_list, createHeighClassLevelList,createHeighClassLevelListFive } from "@/assets/js/select";
    import { statusKV,LevelFilters,typeFilters } from "@/assets/js/status";
    import { high_train_list,orgList } from "@/api/system_manager/api";
    import fiveMixins from '@/minix/fiveMixins';
    export default {
        name: "train-sign-up",
      mixins: [fiveMixins],
        components: {
            "yioks-paging": () => import("@/components/Pagination/Page"),
            "yioks-empty": () => import("@/components/Tips/Empty"),
            "v-icon": () => import("vue-awesome/components/Icon"),
            "yioks-loading": () => import("@/components/Loading/Loading")
        },
        filters: {
            enrollStatusSwitch(status) {
                return (statusKV[status] || {}).text;
            },
            enrollLevel(level) {
                return LevelFilters(level);
            },
          classType(level) {
            return typeFilters(level);
          },
          tipMsg(is_score_unusual_stu, is_repetition_stu, is_has_qualification){
                let tips = [];
                if(is_score_unusual_stu == '1') {
                tips.push('成绩库成绩异常');
                }
                if(is_repetition_stu == '1') {
                tips.push('重复参加此类培训');
                }
                if(is_has_qualification == '1') {
                tips.push('资质审查');
                }
                let resTips = `该培训班中存在${tips.join('、')}的学员`
                if(tips.length) {
                    return resTips;
                } else {
                    return ''
                }
                
            },
        },
        data() {
            const nav = [
                {
                    name: "未审核培训班",
                    status: "Audit"
                },
                {
                    name: "进行中培训班",
                    status: "Incomplete"
                },
                {
                    name: "汇总表",
                    status: ""
                }
            ];
            const levelOptions = [
              {
                label: "E",
                name: "D级助理",
                disabled: true,
              },{
                label: "D",
                name: "D级",
                disabled: true,
              },{
                label: "C",
                name: "C级",
                disabled: false,
              },
                {
                    label: "B",
                    name: "B级",
                    disabled: false,
                },
                {
                    label: "A",
                    name: "A级",
                    disabled: false,
                },
                {
                    label: "P",
                    name: "职业级",
                    disabled: true,
                },
            ];
            return {
                localUserInfo: this.$store.state.userInfo,
                idx: 0, // nav 下标
                nav: nav,
                ops: ops(),
                // levelOptions,
                organList:[],
                class_train_type_list,
                // createHeighClassLevelList,  //  创建培训班级别列表汇总
                classTrainType:class_train_type_list[0].value,
                // classLevel: levelOptions[2].label,
                classLevel: '',
                isLoading: true,
                showEmpty: false,
                selectStatus: HidgClassStatus,
                // class_levels: [{ key: "D级助理", value: "E" }, { key: "D级", value: "D" },{ value: "C", key: "C级" },{ value: "B", key: "B级" },{ value: "A", key: "A级" },{ value: "", key: "全部" }],
//                class_levels: createHeighClassLevelList,
                ifDialogShow: false,
                list: [],
                page: 1,
                paging: {
                    start: 0, // 每页从第几条数据开始
                    prePage: 1, // 一页多少条数据
                    total: 0, // 总页数
                    size: 3, // 页码显示限制
                    last: true, // 尾页
                    next: true, // 下一页
                    first: true, // 首页
                    previous: true, // 上一页
                    jump: true
                },
                selectVal: {
                    class_level: "",
                    status: "",
                    class_train_type: "",
                    keywords: "",
                    org_id:'',
                    year: new Date().getFullYear(),
                },
            };
        },

        computed: {
            levelOptions() {
              if(this.isFive){
                this.classTrainType = 'train'; // 五人制目前就 train 一种类型
                let defaultList = createHeighClassLevelListFive.filter(item => {
                  return item.typeList.includes( this.classTrainType)
                })
                this.classLevel = defaultList[0].value;
                return defaultList;
              }else{
                if(!this.classTrainType) {
                  this.classTrainType = 'continue_education';
                  let defaultList = createHeighClassLevelList.filter(item => {
                    return item.typeList.includes(this.classTrainType)
                  })
                  this.classLevel = defaultList[0].value;
                  return defaultList;
                } else {
                  let defaultList = createHeighClassLevelList.filter(item => {
                    return item.typeList.includes(this.classTrainType)
                  })
                  this.classLevel = defaultList[0].value;
                  return defaultList;
                }
              }
            },
          class_levels(){
            return  this.isFive ? createHeighClassLevelListFive : createHeighClassLevelList;
          },
          // 获取2019年至今的年份数组
          yearList(){
            let year = new Date().getFullYear();
            let yearList = [];
            for(var i = 0; i <= (year-2019); i++ ){
              yearList.push(
                {value:(2019+i), label:(2019+i)},
              );
            }
            return  yearList;
          }
        },
        created() {
            this.getOrganList()
            this.setData();
            this.request();
        },
        methods: {
            setData() {
                const {idx, status, keywords,class_level, page,org_id,class_train_type,year} = this.$route.query;
                page && (this.page = page);
                (Number(idx) === 0 || idx) && (this.idx = Number(idx));
                status && this.$set(this.selectVal, "status", status);
                class_train_type && this.$set(this.selectVal, "class_train_type", class_train_type);
                keywords && this.$set(this.selectVal, "keywords", keywords);
                class_level && this.$set(this.selectVal, "class_level", class_level);
                org_id && this.$set(this.selectVal, "org_id", org_id);
                year && this.$set(this.selectVal, "year", year);
            },
            toCreate() {
              if(!this.classLevel || !this.classTrainType){
                this.$message.error('培训班级别和类型不能为空')
                return
              }
              if(this.isFive){
                this.$router.push({
                  name: "CreateTrainingClassFiveHigh",
                  params: {
                    status: 'New',
                    level: this.classLevel,
                  }
                });
              }else{
                this.$router.push({
                  path: "create_high_class",
                  query:{
                    classLevel:this.classLevel,
                    classTrainType : this.classTrainType
                  }
                })
              }
              
            },
          toClassType(str){
            if (str === 'continue_education') {
              this.levelOptions.find(item => {
                if (item.label === 'C'){
                  item.disabled = false
                }
                if (item.label === 'D' || item.label === 'E'){
                  item.disabled = true
                }
              });
              if (this.classLevel === 'D' || this.classLevel === 'E') {
                this.classLevel = ''
              }
            } else if (str === 'teacher_train') {
              this.levelOptions.find(item => {
                if (item.label === 'C' || item.label === 'D' || item.label === 'E'){
                  item.disabled = false
                }
              });
            } else {
              this.levelOptions.find(item => {
                if (item.label === 'C' || item.label === 'D' || item.label === 'E'){
                  item.disabled = true
                }
              });
              if (this.classLevel === 'C' || this.classLevel === 'D' || this.classLevel === 'E') {
                this.classLevel = ''
              }
            }
          },
            request() {
                this.isLoading = true;
                const postData = {
                    keywords: this.selectVal.keywords,
                    class_level: this.selectVal.class_level,
                    status: this.selectVal.status,
                    class_train_type: this.selectVal.class_train_type,
                    org_id: this.selectVal.org_id,
                    year: this.selectVal.year,
                    page: this.page
                };
                high_train_list(postData)
                    .then((res) => {
                        // console.log(res);
                        const {status, result} = res.data;
                        if (Number(status) === 0) {
                            this.isLoading = false;
                            this.list = result.list
                            this.$set(this.paging, "prePage", result.page.page_size);
                            this.$set(this.paging, "total", result.page.total_row);
                            this.$set(this.paging, "start", (this.page - 1) * this.paging.prePage);
                            // this.showList = result.list.length > 0;
                            this.showEmpty = result.list.length <= 0;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        this.isLoading = false;
                    });
            },
            switchType(str, type) {
                this.$set(this.selectVal, str, type);
                this.search();
            },
            search() {
                this.changeQuery(true);
            },
            hideIcon() {
                this.$set(this.selectVal, "keywords", "");
                this.changeQuery(true);
            },
            gotoPage(start) {
                this.page = parseInt(start / this.paging.prePage) + 1;
                this.changeQuery(false);
                this.$refs['vs'].scrollTo({y: 0});
            },
            lookOver(id) {
                this.$router.push({path: 'class_detail', query: {c_id: id}});
            },
            changeQuery(flag) {
                flag && (this.page = 1);
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        idx: this.idx,
                        keywords: this.selectVal.keywords,
                        page: this.page,
                        class_level: this.selectVal.class_level,
                        status: this.selectVal.status,
                        class_train_type: this.selectVal.class_train_type,
                        org_id:this.selectVal.org_id,
                        year:this.selectVal.year
                    }
                });
                this.request();
            },
            switchTab(index) {
                this.$router.push({path: 'class', query: {idx: index}});
            },
            getOrganList(){
                orgList({}).then(res=>{
                    const {organization}=res.data.result;
                    this.organList=organization;
                }).catch(err=>{

                })
            },
        }
    };
</script>

<style lang="stylus" scoped>
    @import '~@/assets/css/variable';
    @import '~@/assets/css/mixin';
    @import '~@/assets/css/nav_filter';

    .train-sign-up-root {
        zuxie-page-root();

        .main-content-wrap {
            color: $color_white;
            font-size: $font_size_medium;
            line-height: inherit;

            .nav_filter_wrap {
                .main_wrap{
                    .line{
                        height 18px
                        border-right 1px solid #FFF
                    }
                    .btn{
                        padding: 5px 10px
                    }
                }
                .down_wrap {
                    height 36px //解决浮动
                    .filter_line {
                        float right
                        .item {
                            margin-right: 5px;
                        }
                    }
                }
            }
        }

        .classMain {
            display: flex;
            flex-direction: column;
            height: 620px;
            width: 100%;
            padding: 20px 0 0;
            background-color: $block_bg_color_base;
            .searchWrap {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 40px;
                margin: 0 40px 30px;
                .selectWrap {
                    height: 100%;
                    display: flex;
                    select {
                        width: 195px;
                        // height: 100%;
                        padding: 0 15px;
                        font-size: $font_size_medium;
                        color: $color_black;
                        outline: none;
                        &+select {
                            margin-left 11px
                        }
                    }
                }
                .search {
                    // width: 390px;
                    height: 100%;
                    display: flex;
                    justify-content: flex-end;
                    // align-items: center;
                    .wrap {
                        height: 100%;
                        position: relative;
                        input {
                            width: 160px;
                            height: 100%;
                            padding: 0 20px 0 10px;
                            font-size: $font_size_medium;
                            color: $color_black;
                            outline: none;
                        }
                        .close {
                            position: absolute;
                            right: 1px;
                            top: 10px;
                            color: $color_info;
                            cursor: pointer;
                        }
                    }
                    .searchBtn {
                        width: 90px;
                        // height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 20px;
                        background-color: $color_suc;
                        cursor: pointer;
                        user-select: none;
                    }
                    .zuxie-btn{
                        margin-left 20px
                        background-color #5ac8fa
                    }
                }
            }
            .table {
                display flex
                flex-direction column
                // height 450px
                flex 1
                width: 100%;
                .thead, .tbody {
                    border: 1px solid $color_white;
                }
                .thead {
                    margin: 0 40px;
                    .tr {
                        height: 45px;
                        display: flex;
                    }
                }
                .scrollArea {
                    // height 425px
                    height 370px
                    /*flex 1*/
                    /*overflow hidden*/
                }
                .tbodyWrap {
                    display block
                    // padding: 0 40px;
                }
                .tbody {
                    display block
                    width 810px
                    margin-left auto
                    margin-right auto
                    max-width: 810px;
                    border-top: none;
                    border-bottom: none;
                    .tr {
                        height: 49px;
                        display: flex;
                        border-bottom: 1px solid $color_white;
                    }
                }
                .th, .td {
                    height: 100%;
                    /*flex: 1 1 auto;*/
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: $font_size_medium;
                    border-right: 1px solid $color_white;
                }
                .th:last-child, .td:last-child {
                    border-right: none;
                }
                .td{
                    p{
                        over_hide();
                        text-align: center;
                        color:$color_white;
                    }
                }

                .index {
                    width: 6%;
                }
                .name {
                    width: 16%;
                }
                .date {
                    width: 26%;
                }
                .level {
                    width: 12%;
                }
                .class_type {
                    width: 13%;
                }
                .num {
                    width: 6%;
                }
                .status {
                    width: 14%;
                    .subStatus {
                        font-size: 12px;
                    }
                }
                .opt {
                    width: 7%;
                    p {
                        cursor: pointer;
                        user-select: none;
                        color: $color_suc;
                        &.msg_err {
                             color: $color_normal_err;
                        }
                    }
                }
            }
            .empty_wrap {
                flex 1
                width: 100%;
            }
            .paging {
                width: 100%;
                // height: 60px;
                padding 25px 0 10px
            }

            .searchWrap {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 40px;
                margin: 0 40px 30px;
            }
        }
        .create-high-train-dialog {
            .title {
                font-size 18px
            }
            .radio-wrap {
                // display block
                // padding 40px 0
                // text-align center
                padding 40px 0 0 0
                display flex
                .radio-title {
                    width 80px
                    height 40px
                    display: flex
                    justify-content: center
                    align-items: center
                }
                .radio-content {
                    width 560px
                    text-indent: 10px
                    .radio-item {
                    margin-bottom 10px
                    }
                }
            }
            
            .dia-footer {
                display block
                text-align center
                margin-top 40px
            }
        }
    }

    
.w360
    width 360px
</style>
<style lang="stylus">
    .train-sign-up-root {
        .create-high-train-dialog {
            .el-dialog__header {
                padding 0
            }
        }
    }
</style>

